import React, { useState } from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';


const initialValues = {
    person: {},
    title: '',
    iban: '',
    address: '',
    phone: '',
    guildId: '',
    subGuildId: '',
    website: '',
    telegram: '',
    instagram: '',
    photo1: '',
    doc1: '',
    doc2: '',
    doc3: '',
    doc4: '',
    doc5: '',
    doc6: '',
    doc7: '',
    photo2: '',
    photo3: '',
    photo4: '',
    photo5: '',
    photo6: '',
    lat: '',
    lang: '',
    ip11: '',
    ip12: '',
    ip13: '',
    ip14: '',
    provinceId: 0,
    cityId: 0,
    supportPhones: '',
    terminals: [
        {
            terminalNo: '',
            acceptorId: '',
            serialNo: ''
        }
    ],
    works: [

        {
            dayId: 1,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 2,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 3,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 4,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 5,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 6,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
            dayId: 7,
            openTime: '',
            closeTime: '',
            businessId: 0,
        },
        {
          dayId: 1,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 2,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 3,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 4,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 5,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 6,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
        {
          dayId: 7,
          openTime: "",
          closeTime: "",
          businessId: 0,
        },
    ]
};

const validationSchema = Yup.object({
    person: Yup.object({
        name: Yup.string().required()
    }),
    ip11: Yup.string()
        .test('ip11', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip12: Yup.string()
        .test('ip12', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip13: Yup.string()
        .test('ip13', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip14: Yup.string()
        .test('ip14', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip21: Yup.string()
        .test('ip21', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip22: Yup.string()
        .test('ip22', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip23: Yup.string()
        .test('ip23', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip24: Yup.string()
        .test('ip24', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip31: Yup.string()
        .test('ip31', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip32: Yup.string()
        .test('ip32', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip33: Yup.string()
        .test('ip33', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    ip34: Yup.string()
        .test('ip34', ' ', value => {
            if (value) {
                return value && /^\d+$/.test(value.toString().replace('-', '')) && /^\d+$/.test(value.toString().replace(' ', '')) &&
                    !value.startsWith('0') && value <= 255;
            } else {
                if (value === undefined) return true;
                else return true;
            }
        }),
    title: Yup.string()
        .required(),
    address: Yup.string()
        .min(10, '')
        .required(),

    iban: Yup.string()
        .required(),

    guildId: Yup.number()
        .required(),
    provinceId: Yup.number()
        .required(),
    subGuildId: Yup.number()
        .required()
});

const Create = () => {

    const { addData } = useEntityCrud('Business/SetBusiness');
    const { addData: addPhotoRequest } = useEntityCrud('PhotoRequest/setPhotoRequests');
    const { addData: addBusinessDocs } = useEntityCrud('Business/setDocument');
    const { addData: addWorkTime } = useEntityCrud('Business/setWorkingTimes');

    const navigate = useNavigate();
    const [markerPosCreate, setMarkerPosCreate] = useState({})


    function timeStringToFloat(time) {
        const str = time;
        const newStr = str.replace(':', '');
        const intTime = parseInt(newStr)
        return intTime;
    }



    const dd = () => {

        const postedData2 = []
        formik.values.works.filter(item => item.dayId !== 0).map((item, index) => {

            postedData2.push({
                dayId: item.dayId,
                openTime: (item.openTime),
                closeTime: (item.closeTime),
                businessId: 618,
            });
        })

        addWorkTime(postedData2).then(({ data }) => {

            console.log(data.result);
        })

    }


    const onSubmit = (values) => {

        const p1 = (values.ip11 || '') + "." + (values.ip12 || '') + "." + (values.ip13 || '') + "." + (values.ip14 || '');
        const p2 = (values.ip21 || '') + "." + (values.ip22 || '') + "." + (values.ip23 || '') + "." + (values.ip24 || '');
        const p3 = (values.ip31 || '') + "." + (values.ip32 || '') + "." + (values.ip33 || '') + "." + (values.ip34 || '');
        const ip_ = (p1 && (p2 === "undefined.undefined.undefined.undefined") &&
            (p3 === "undefined.undefined.undefined.undefined")) ? (p1) :
            (p1 && p2 && (p3 === "undefined.undefined.undefined.undefined")) ? (p1 + "," + p2) :
                (p1 && p2 && p3) ? (p1 + "," + p2 + "," + p3) :
                    (p1 && (p2 === "undefined.undefined.undefined.undefined") && p3) ? (p1 + "," + p3) : ""

        document.getElementById('btn-submit-form').classList.add('btn-loading');
        const postedData = {
            title: values.title,
            address: values.address,
            phone: values.phone ? values.phone.replace('-', '') : '',
            postalCode: values.postalCode,
            iban: (values.iban).replaceAll("-", ""),
            onlinePayment: values.onlinePayment,
            walletPayment: values.walletPayment,
            guildId: values.guildId,
            subGuildId: values.subGuildId,
            terminalNo: values.terminals[0].terminalNo,
            acceptorId: values.terminals[0].acceptorId,
            serialNo: values.terminals[0].serialNo,
            website: values.website,
            telegram: values.telegram,
            instagram: values.instagram,
            ip: ip_,
            // logo: values.logo ? values.logo.split('base64,')[1] : '',
            lat: parseFloat(formik.values.lat).toFixed(4),
            lang: parseFloat(formik.values.lang).toFixed(4),
            cityId: values.cityId,
            // photo1: values.photo1 ? values.photo1.split('base64,')[1] : '',
            // photo2: values.photo2 ? values.photo2.split('base64,')[1] : '',
            // photo3: values.photo3 ? values.photo3.split('base64,')[1] : '',
            // photo4: values.photo4 ? values.photo4.split('base64,')[1] : '',
            // photo5: values.photo5 ? values.photo5.split('base64,')[1] : '',
            // photo6: values.photo6 ? values.photo6.split('base64,')[1] : '',
            terminals: values.terminals,
            guildTitle: '',
            subGuildtitle: '',
            paymentTypes: values.paymentTypes,
            person: {
                name: values.person?.name,
                lastName: values.person?.lastName,
                nationalCode: values.person?.nationalCode,
                birthDate: values.birthDate,
                cellphone: values.person?.cellphone.replace('-', '')
            },
            countPerBasket: parseInt(values.countPerBasket)
        };
        addData(postedData).then(({ data }) => {
            if (data.status) {
                if(values.logo != null && values.logo != '' && values.logo.includes('base64,')){
                    const logoPostedData = {
                        photoId: i,
                        photoContent: values.logo.split('base64,')[1],
                        businessId: data.result.id
                    }
                    addPhotoRequest(logoPostedData);
                }
                for(let i = 1;i < 7;i++){
                    if(values[`photo${i}`] != null && values[`photo${i}`] != '' && values[`photo${i}`].includes('base64,')){
                        const imagePostedData = {
                            photoId: i,
                            photoContent: values[`photo${i}`].split('base64,')[1],
                            businessId: data.result.id
                        }
                        addPhotoRequest(imagePostedData);
                    }
                }
                for (var i = 1; i <= 8; i++) {
                    const postedData = {
                        docTypeId: i,
                        docContent: i === i ? (formik.values['doc' + i] ? formik.values['doc' + i].split('base64,')[1] : '') : "",
                        buisnessId: data.result.id
                    }
                    addBusinessDocs(postedData).then(({ data }) => {
                        console.log(data.result);
                    })
                }

                const postedData2 = []
                formik.values.works.filter(item => item.dayId !== 0).map((item, index) => {

                    postedData2.push({
                        dayId: item.dayId,
                        openTime: (item.openTime),
                        closeTime: (item.closeTime),
                        businessId: data.result.id,
                    });
                })

                addWorkTime(postedData2).then(({ data }) => {

                    console.log(data.result);
                })

                toast.success('کسب و کار جدید با موفقیت ایجاد شد');
                return navigate('/organizations');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });



    const handleBack = () => {
        navigate('/organizations', { replace: true });
    }





    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد کسب و کار جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} dd={dd}
                    markerPosCreate={markerPosCreate}
                    setMarkerPosCreate={setMarkerPosCreate}
                />
            </div>
        </div>
    );
}

export default Create;

